import * as React from 'react';

import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { PositionDetailFooter as Footer } from './components/Footer';
import { actions } from 'actions';

import { Buy } from './components/Buy';
import Sell from './components/Sell';
import { mapStateToProps, Data, SelectorResult, responseToProps } from './selectors';
import * as query from './query.gql';
import {
  StockPositionDetailsQuery,
  StockPositionDetailsQueryVariables,
} from './__generated__/StockPositionDetailsQuery';

import { PositionDetailModalView } from 'components/PositionDetailsModal';

export interface Props {}

const mapDispatchToProps = {
  close: actions.hideDetailModal,
};

type BodyProps = { transactions: Data['transactions'] };

type Enhanced = Props & InjectedTranslateProps & SelectorResult & typeof mapDispatchToProps & Data;

const enhance = compose<Enhanced, Props>(
  translate,
  connect(mapStateToProps, mapDispatchToProps),
  graphql<
    Props & SelectorResult,
    StockPositionDetailsQuery,
    StockPositionDetailsQueryVariables,
    Data
  >(query, {
    skip: ({ positionId }) => !positionId,
    options: ({ positionId }) => {
      return {
        variables: {
          id: positionId!,
        },
        errorPolicy: 'all',
      };
    },
    props: responseToProps,
  })
);

function Body({ transactions }: BodyProps) {
  if (!transactions) {
    return null;
  }
  return (
    <>
      {transactions.map((transaction, i) => {
        switch (transaction.operationType) {
          case 'BUY':
            return <Buy key={i} transaction={transaction} />;
          case 'SELL':
            return <Sell key={i} transaction={transaction} />;
          default:
            return null;
        }
      })}
    </>
  );
}

function StockPositionDetailsModal({ close, t, loading, transactions, summary }: Enhanced) {
  return (
    <PositionDetailModalView
      footer={<Footer summary={summary} />}
      isLoading={loading}
      onClose={close}
    >
      <Body transactions={transactions} />
    </PositionDetailModalView>
  );
}

export default enhance(StockPositionDetailsModal);
